webpackJsonp([8,9],{

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactLocalization = __webpack_require__(418);

var _reactLocalization2 = _interopRequireDefault(_reactLocalization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var strings = new _reactLocalization2.default({
  en: {
    home_label: "Home",
    services_label: "Services",
    projects_label: "Projects",
    clients_label: "Clients",
    social_label: "Social",
    about_label: "About",
    about_us_label: "About us",
    work_here_label: "Work Here!",
    team_label: "Team",
    contact_label: "Contact",
    privacy_policy_label: "Privacy policy",
    careers_label: "Careers",
    open_positions_label: "Open positions",
    hiring_process_label: "Hiring Process",
    work_culture_label: "Work culture",
    intern_with_us: "Intern With Us!",
    rebrand_label: "We've rebranded!"
  }
});

exports.default = strings;

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Simple module to localize the React interface using the same syntax
 * used in the ReactNativeLocalization module
 * (https://github.com/stefalda/ReactNativeLocalization)
 *
 * Originally developed by Stefano Falda (stefano.falda@gmail.com)
 *
 * It uses a call to the Navigator/Browser object to get the current interface language,
 * then display the correct language strings or the default language (the first
 * one if a match is not found).
 *
 * This library has been refactored to use the newly created localized-strings package so to
 * unify the code and make it easier to mantain
 *
 * How to use:
 * Check the instructions at:
 * https://github.com/stefalda/react-localization
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _localizedStrings = __webpack_require__(419);

var _localizedStrings2 = _interopRequireDefault(_localizedStrings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var placeholderRegex = /(\{[\d|\w]+\})/;

/**
 * Format the passed string replacing the numbered or tokenized placeholders
 * eg. 1: I'd like some {0} and {1}, or just {0}
 * eg. 2: I'd like some {bread} and {butter}, or just {bread}
 * Use example:
 * eg. 1: strings.formatString(strings.question, strings.bread, strings.butter)
 * eg. 2: strings.formatString(strings.question, { bread: strings.bread, butter: strings.butter }
 *
 * THIS METHOD OVERRIDE the one of the parent class by adding support for JSX code
*/
_localizedStrings2.default.prototype.formatString = function (str) {
  for (var _len = arguments.length, valuesForPlaceholders = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    valuesForPlaceholders[_key - 1] = arguments[_key];
  }

  var hasObject = false;
  var res = (str || '').split(placeholderRegex).filter(function (textPart) {
    return !!textPart;
  }).map(function (textPart, index) {
    if (textPart.match(placeholderRegex)) {
      var matchedKey = textPart.slice(1, -1);
      var valueForPlaceholder = valuesForPlaceholders[matchedKey];

      // If no value found, check if working with an object instead
      if (valueForPlaceholder == undefined) {
        var valueFromObjectPlaceholder = valuesForPlaceholders[0][matchedKey];
        if (valueFromObjectPlaceholder !== undefined) {
          valueForPlaceholder = valueFromObjectPlaceholder;
        } else {
          // If value still isn't found, then it must have been undefined/null
          return valueForPlaceholder;
        }
      }

      if (_react2.default.isValidElement(valueForPlaceholder)) {
        hasObject = true;
        return _react2.default.Children.toArray(valueForPlaceholder).map(function (component) {
          return _extends({}, component, { key: index.toString() });
        });
      }

      return valueForPlaceholder;
    }
    return textPart;
  });
  // If the results contains a object return an array otherwise return a string
  if (hasObject) return res;
  return res.join('');
};

exports.default = _localizedStrings2.default;

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(420);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Simple module to localize the React interface using the same syntax
 * used in the ReactNativeLocalization module
 * (https://github.com/stefalda/ReactNativeLocalization)
 *
 * Originally developed by Stefano Falda (stefano.falda@gmail.com)
 *
 * It uses a call to the Navigator/Browser object to get the current interface language,
 * then display the correct language strings or the default language (the first
 * one if a match is not found).
 *
 * How to use:
 * Check the instructions at:
 * https://github.com/stefalda/localized-strings
 */

var placeholderReplaceRegex = /(\{[\d|\w]+\})/;
var placeholderReferenceRegex = /(\$ref\{[\w|.]+\})/;

var LocalizedStrings = function () {
  /**
   * Constructor used to provide the strings objects in various language and the optional callback to get
   * the interface language
   * @param {*} props - the strings object
   * @param {Function} options.customLanguageInterface - the optional method to use to get the InterfaceLanguage
   * @param {Boolean} options.pseudo - convert all strings to pseudo, helpful when implementing
   * @param {Boolean} options.pseudoMultipleLanguages - add 40% to pseudo, helps with translations in the future
   * @param {Boolean} options.logsEnabled - Enable/Disable console.log outputs (default=true)
   */
  function LocalizedStrings(props, options) {
    _classCallCheck(this, LocalizedStrings);

    // Compatibility fix with previous version
    if (typeof options === "function") {
      /* eslint-disable no-param-reassign */
      options = { customLanguageInterface: options };
      /* eslint-enable */
    }
    this._opts = _extends({}, {
      customLanguageInterface: utils.getInterfaceLanguage,
      pseudo: false,
      pseudoMultipleLanguages: false,
      logsEnabled: true
    }, options);
    this._interfaceLanguage = this._opts.customLanguageInterface();
    this._language = this._interfaceLanguage;
    this.setContent(props);
  }

  /**
   * Set the strings objects based on the parameter passed in the constructor
   * @param {*} props
   */


  _createClass(LocalizedStrings, [{
    key: "setContent",
    value: function setContent(props) {
      var _this = this;

      var _Object$keys = Object.keys(props),
          _Object$keys2 = _slicedToArray(_Object$keys, 1),
          defaultLang = _Object$keys2[0];

      this._defaultLanguage = defaultLang;
      this._defaultLanguageFirstLevelKeys = [];
      // Store locally the passed strings
      this._props = props;
      utils.validateTranslationKeys(Object.keys(props[this._defaultLanguage]));
      // Store first level keys (for identifying missing translations)
      Object.keys(this._props[this._defaultLanguage]).forEach(function (key) {
        if (typeof _this._props[_this._defaultLanguage][key] === "string") {
          _this._defaultLanguageFirstLevelKeys.push(key);
        }
      });
      // Set language to its default value (the interface)
      this.setLanguage(this._interfaceLanguage);
      // Developermode with pseudo
      if (this._opts.pseudo) {
        this._pseudoAllValues(this._props);
      }
    }

    /**
     * Replace all strings to pseudo value
     * @param {Object} obj - Loopable object
     */

  }, {
    key: "_pseudoAllValues",
    value: function _pseudoAllValues(obj) {
      var _this2 = this;

      Object.keys(obj).forEach(function (property) {
        if (_typeof(obj[property]) === "object") {
          _this2._pseudoAllValues(obj[property]);
        } else if (typeof obj[property] === "string") {
          if (obj[property].indexOf("[") === 0 && obj[property].lastIndexOf("]") === obj[property].length - 1) {
            // already psuedo fixed
            return;
          }
          // @TODO must be a way to get regex to find all replaceble strings except our replacement variables
          var strArr = obj[property].split(" ");
          for (var i = 0; i < strArr.length; i += 1) {
            if (strArr[i].match(placeholderReplaceRegex)) {
              // we want to keep this string, includes specials
            } else if (strArr[i].match(placeholderReferenceRegex)) {
              // we want to keep this string, includes specials
            } else {
              var len = strArr[i].length;
              if (_this2._opts.pseudoMultipleLanguages) {
                len = parseInt(len * 1.4, 10); // add length with 40%
              }
              strArr[i] = utils.randomPseudo(len);
            }
          }
          obj[property] = "[" + strArr.join(" ") + "]"; // eslint-disable-line no-param-reassign
        }
      });
    }

    /**
     * Can be used from ouside the class to force a particular language
     * indipendently from the interface one
     * @param {*} language
     */

  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      var _this3 = this;

      // Check if exists a translation for the current language or if the default
      // should be used
      var bestLanguage = utils.getBestMatchingLanguage(language, this._props);
      var defaultLanguage = Object.keys(this._props)[0];
      this._language = bestLanguage;
      // Associate the language object to the this object
      if (this._props[bestLanguage]) {
        // delete default propery values to identify missing translations
        for (var i = 0; i < this._defaultLanguageFirstLevelKeys.length; i += 1) {
          delete this[this._defaultLanguageFirstLevelKeys[i]];
        }
        var localizedStrings = _extends({}, this._props[this._language]);
        Object.keys(localizedStrings).forEach(function (key) {
          _this3[key] = localizedStrings[key];
        });
        // Now add any string missing from the translation but existing in the default language
        if (defaultLanguage !== this._language) {
          localizedStrings = this._props[defaultLanguage];
          this._fallbackValues(localizedStrings, this);
        }
      }
    }

    /**
     * Load fallback values for missing translations
     * @param {*} defaultStrings
     * @param {*} strings
     */

  }, {
    key: "_fallbackValues",
    value: function _fallbackValues(defaultStrings, strings) {
      var _this4 = this;

      Object.keys(defaultStrings).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(defaultStrings, key) && !strings[key] && strings[key] !== "") {
          strings[key] = defaultStrings[key]; // eslint-disable-line no-param-reassign
          if (_this4._opts.logsEnabled) {
            console.log("\uD83D\uDEA7 \uD83D\uDC77 key '" + key + "' not found in localizedStrings for language " + _this4._language + " \uD83D\uDEA7");
          }
        } else if (typeof strings[key] !== "string") {
          // It's an object
          _this4._fallbackValues(defaultStrings[key], strings[key]);
        }
      });
    }

    /**
     * The current language displayed (could differ from the interface language
     * if it has been forced manually and a matching translation has been found)
     */

  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this._language;
    }

    /**
     * The current interface language (could differ from the language displayed)
     */

  }, {
    key: "getInterfaceLanguage",
    value: function getInterfaceLanguage() {
      return this._interfaceLanguage;
    }

    /**
     * Return an array containing the available languages passed as props in the constructor
     */

  }, {
    key: "getAvailableLanguages",
    value: function getAvailableLanguages() {
      var _this5 = this;

      if (!this._availableLanguages) {
        this._availableLanguages = [];
        Object.keys(this._props).forEach(function (key) {
          _this5._availableLanguages.push(key);
        });
      }
      return this._availableLanguages;
    }

    // Format the passed string replacing the numbered or tokenized placeholders
    // eg. 1: I'd like some {0} and {1}, or just {0}
    // eg. 2: I'd like some {bread} and {butter}, or just {bread}
    // eg. 3: I'd like some $ref{bread} and $ref{butter}, or just $ref{bread}
    // Use example:
    // eg. 1: strings.formatString(strings.question, strings.bread, strings.butter)
    // eg. 2: strings.formatString(strings.question, { bread: strings.bread, butter: strings.butter })
    // eg. 3: strings.formatString(strings.question)

  }, {
    key: "formatString",
    value: function formatString(str) {
      var _this6 = this;

      for (var _len = arguments.length, valuesForPlaceholders = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        valuesForPlaceholders[_key - 1] = arguments[_key];
      }

      var input = str || "";
      if (typeof input === "string") {
        input = this.getString(str, null, true) || input;
      }
      var ref = input.split(placeholderReferenceRegex).filter(function (textPart) {
        return !!textPart;
      }).map(function (textPart) {
        if (textPart.match(placeholderReferenceRegex)) {
          var matchedKey = textPart.slice(5, -1);
          var referenceValue = _this6.getString(matchedKey);
          if (referenceValue) return referenceValue;
          if (_this6._opts.logsEnabled) {
            console.log("No Localization ref found for '" + textPart + "' in string '" + str + "'");
          }
          // lets print it another way so next replacer doesn't find it
          return "$ref(id:" + matchedKey + ")";
        }
        return textPart;
      }).join("");
      return ref.split(placeholderReplaceRegex).filter(function (textPart) {
        return !!textPart;
      }).map(function (textPart) {
        if (textPart.match(placeholderReplaceRegex)) {
          var matchedKey = textPart.slice(1, -1);
          var valueForPlaceholder = valuesForPlaceholders[matchedKey];
          // If no value found, check if working with an object instead
          if (valueForPlaceholder === undefined) {
            var valueFromObjectPlaceholder = valuesForPlaceholders[0][matchedKey];
            if (valueFromObjectPlaceholder !== undefined) {
              valueForPlaceholder = valueFromObjectPlaceholder;
            } else {
              // If value still isn't found, then it must have been undefined/null
              return valueForPlaceholder;
            }
          }

          return valueForPlaceholder;
        }
        return textPart;
      }).join("");
    }

    // Return a string with the passed key in a different language or defalt if not set
    // We allow deep . notation for finding strings

  }, {
    key: "getString",
    value: function getString(key, language) {
      var omitWarning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      try {
        var current = this._props[language || this._language];
        var paths = key.split(".");
        for (var i = 0; i < paths.length; i += 1) {
          if (current[paths[i]] === undefined) {
            throw Error(paths[i]);
          }
          current = current[paths[i]];
        }
        return current;
      } catch (ex) {
        if (!omitWarning && this._opts.logsEnabled) {
          console.log("No localization found for key '" + key + "' and language '" + language + "', failed on " + ex.message);
        }
      }
      return null;
    }

    /**
     * The current props (locale object)
     */

  }, {
    key: "getContent",
    value: function getContent() {
      return this._props;
    }
  }]);

  return LocalizedStrings;
}();

exports.default = LocalizedStrings;

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInterfaceLanguage = getInterfaceLanguage;
exports.getBestMatchingLanguage = getBestMatchingLanguage;
exports.validateTranslationKeys = validateTranslationKeys;
exports.randomPseudo = randomPseudo;
/**
 * Return the current interface language
 * If the navigator object is defined it returns the current navigator language
 * otherwise it falls back to 'en-US'
 * Works in browsers
 */
function getInterfaceLanguage() {
  var defaultLang = 'en-US';
  if (typeof navigator === 'undefined') {
    return defaultLang;
  }
  var nav = navigator; // eslint-disable-line no-undef
  if (nav) {
    if (nav.language) {
      return nav.language;
    }
    if (!!nav.languages && !!nav.languages[0]) {
      return nav.languages[0];
    }
    if (nav.userLanguage) {
      return nav.userLanguage;
    }
    if (nav.browserLanguage) {
      return nav.browserLanguage;
    }
  }
  return defaultLang;
}

/**
 * Get the best match based on the language passed and the available languages
 * @param {*} language
 * @param {*} props
 */
function getBestMatchingLanguage(language, props) {
  // If an object with the passed language key exists return it
  if (props[language]) return language;

  // if the string is composed try to find a match with only the first language identifiers (en-US --> en)
  var idx = language.indexOf('-');
  var auxLang = idx >= 0 ? language.substring(0, idx) : language;
  return props[auxLang] ? auxLang : Object.keys(props)[0];
}

/**
 * Check that the keys used in the provided strings object don't collide with existing property
 * already defined in the LocalizedStrings object
 * @param {*} translationKeys
 */
function validateTranslationKeys(translationKeys) {
  var reservedNames = ['_interfaceLanguage', '_language', '_defaultLanguage', '_defaultLanguageFirstLevelKeys', '_props'];
  translationKeys.forEach(function (key) {
    if (reservedNames.indexOf(key) !== -1) {
      throw new Error(key + ' cannot be used as a key. It is a reserved word.');
    }
  });
}

/**
 * Get a random pseudo string back after specified a length
 * @param {Number} len - How many characters to get back
 */
function randomPseudo(len) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < len; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }return text;
}

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer(props) {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "subfooter" },
        _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col-md-12 col-lg-12" },
              _react2.default.createElement(
                "p",
                { className: "text-center" },
                "Copyright \xA9 2017 NicheSolv",
                _react2.default.createElement("font", { color: "olivedrab" })
              )
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react2.default.Component);

exports.default = Footer;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _localization = __webpack_require__(417);

var _localization2 = _interopRequireDefault(_localization);

var _reactRouterDom = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      selectedButton: _this.props.page,
      headerStyle: "header-transparent"
    };
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(Header, [{
    key: "setFilter",
    value: function setFilter(filter) {
      this.setState({ selectedButton: filter });
      var scrollToElement = document.getElementById(filter);
      if (scrollToElement && (filter === "privacypolicy" || filter === "contact")) {
        // scrollToElement.scrollIntoView()
        window.scrollTo({
          top: scrollToElement.offsetTop,
          behavior: "instant"
        });
      }
    }
  }, {
    key: "handleDropdownItemClick",
    value: function handleDropdownItemClick(e) {
      console.log("inside ");
      e.preventDefault();
      // this.showDropdown = true;
    }
  }, {
    key: "isActive",
    value: function isActive(value) {
      return value === this.state.selectedButton ? "a" : "";
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.page) {
        this.setState({ selectedButton: nextProps.page });
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(event) {
      var scrollTop = event.srcElement.body.scrollTop,
          itemTranslate = Math.min(0, scrollTop / 3 - 60);
      this.setState({
        headerStyle: "header"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "header",
        {
          className: "fixed clearfix navbar navbar-fixed-top " + this.state.headerStyle
        },
        _react2.default.createElement(
          "div",
          { className: "container-fluid" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col-sm-3 col-md-3 col-lg-3 abcd" },
              _react2.default.createElement(
                "div",
                { className: "header-left clearfix" },
                _react2.default.createElement(
                  "div",
                  { className: "logo smooth-scroll" },
                  " ",
                  _react2.default.createElement(
                    "a",
                    { href: "#banner" },
                    " ",
                    _react2.default.createElement("img", {
                      id: "logo",
                      src: "/images/nichesoft.png",
                      alt: "NicheSolv"
                    }),
                    " "
                  ),
                  " "
                ),
                _react2.default.createElement(
                  "div",
                  { className: "site-name-and-slogan smooth-scroll" },
                  _react2.default.createElement(
                    "div",
                    { className: "site-name" },
                    " ",
                    _react2.default.createElement(
                      "a",
                      { href: "#banner" },
                      " NicheSolv "
                    ),
                    " "
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "site-slogan", id: "slog" },
                    "Your Ideas, Our Code"
                  )
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col-md-9 col-lg-9" },
              _react2.default.createElement(
                "div",
                { className: "header-right clearfix" },
                _react2.default.createElement(
                  "div",
                  { className: "main-navigation animated" },
                  _react2.default.createElement(
                    "nav",
                    {
                      className: "navbar navbar-default navbar-fixed-top",
                      role: "navigation"
                    },
                    _react2.default.createElement(
                      "div",
                      { className: "container-fluid" },
                      _react2.default.createElement(
                        "div",
                        { className: "navbar-header" },
                        _react2.default.createElement(
                          "button",
                          {
                            type: "button",
                            className: "navbar-toggle collapsed",
                            "data-toggle": "collapse",
                            "data-target": "#navbar-collapse-2",
                            "aria-expanded": "false"
                          },
                          _react2.default.createElement(
                            "span",
                            { className: "sr-only" },
                            "Toggle navigation"
                          ),
                          " ",
                          _react2.default.createElement("span", { className: "icon-bar" }),
                          " ",
                          _react2.default.createElement("span", { className: "icon-bar" }),
                          " ",
                          _react2.default.createElement("span", { className: "icon-bar" })
                        ),
                        _react2.default.createElement(
                          "div",
                          { className: "header-left clearfix disp" },
                          _react2.default.createElement(
                            "div",
                            { className: "logo smooth-scroll" },
                            " ",
                            _react2.default.createElement(
                              "a",
                              { href: "#banner" },
                              " ",
                              _react2.default.createElement("img", {
                                id: "logo1",
                                src: "/images/nichesoft.png",
                                alt: "NicheSolv"
                              }),
                              " "
                            ),
                            " "
                          ),
                          _react2.default.createElement(
                            "div",
                            { className: "site-name-and-slogan smooth-scroll" },
                            _react2.default.createElement(
                              "div",
                              { className: "site-name1" },
                              " ",
                              _react2.default.createElement(
                                "a",
                                { href: "#banner" },
                                " NicheSolv "
                              ),
                              " "
                            ),
                            _react2.default.createElement(
                              "div",
                              { className: "site-slogan1", id: "slog" },
                              " ",
                              "Your Ideas, Our Code",
                              " "
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        "div",
                        {
                          className: "collapse navbar-collapse scrollspy smooth-scroll",
                          id: "navbar-collapse-2"
                        },
                        _react2.default.createElement(
                          "ul",
                          { className: "nav navbar-nav navbar-right" },
                          _react2.default.createElement(
                            "li",
                            {
                              id: "hom",
                              className: this.isActive("home") + " hidden-xs"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              { to: "/#home" },
                              _localization2.default.home_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: this.isActive("services") + " hidden-xs"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/#services",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.services_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              id: "proj",
                              className: this.isActive("projects") + " hidden-xs",
                              onClick: function onClick() {
                                return _this2.setFilter("projects");
                              }
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                id: "navProjects",
                                to: "/#projects",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.projects_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: this.isActive("clients") + " hidden-xs",
                              onClick: function onClick() {
                                return _this2.setFilter("clients");
                              }
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                id: "navClient",
                                to: "/#clients",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.clients_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              id: "hom",
                              className: this.isActive("home") + " hidden-lg hidden-sm hidden-md",
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              { to: "/#home" },
                              _localization2.default.home_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: this.isActive("services") + " hidden-lg hidden-sm hidden-md",
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/#services",
                                id: "navServices",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.services_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              id: "proj",
                              className: this.isActive("projects") + " hidden-lg hidden-sm hidden-md",
                              onClick: function onClick() {
                                return _this2.setFilter("projects");
                              },
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                id: "navProjects",
                                to: "/#projects",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.projects_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: this.isActive("clients") + " hidden-lg hidden-sm hidden-md",
                              onClick: function onClick() {
                                return _this2.setFilter("clients");
                              },
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                id: "navClient",
                                to: "/#clients",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.clients_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            { className: "hidden-xs", id: "abt" },
                            _react2.default.createElement(
                              "a",
                              {
                                href: "#",
                                onClick: this.handleDropdownItemClick,
                                "data-toggle": "dropdown"
                              },
                              _localization2.default.careers_label,
                              _react2.default.createElement("b", { className: "caret" })
                            ),
                            _react2.default.createElement(
                              "ul",
                              { className: "dropdown-menu" },
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("openPositions") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  { to: "/openPositions" },
                                  _localization2.default.open_positions_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("work") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  {
                                    to: "/#workhere",
                                    onClick: this.props.trackScrolling
                                  },
                                  _localization2.default.work_culture_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("hiringProcess") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  { to: "/hiringProcess" },
                                  _localization2.default.hiring_process_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("internWithUs") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  { to: "/internWithUs" },
                                  _localization2.default.intern_with_us
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            { className: "hidden-xs", id: "abt" },
                            _react2.default.createElement(
                              "a",
                              { href: "#", "data-toggle": "dropdown" },
                              _localization2.default.about_label,
                              _react2.default.createElement("b", { className: "caret" })
                            ),
                            _react2.default.createElement(
                              "ul",
                              { className: "dropdown-menu" },
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("about") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  {
                                    to: "/#about",
                                    onClick: this.props.trackScrolling
                                  },
                                  _localization2.default.about_us_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("team") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  {
                                    id: "navTeam",
                                    to: "/#team",
                                    onClick: this.props.trackScrolling
                                  },
                                  _localization2.default.team_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("social") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  {
                                    id: "navSocial",
                                    to: "/#social",
                                    onClick: this.props.trackScrolling
                                  },
                                  _localization2.default.social_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("contact") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  {
                                    to: "/#contact",
                                    onClick: function onClick() {
                                      return _this2.setFilter("contact");
                                    }
                                  },
                                  _localization2.default.contact_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("privacypolicy") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  {
                                    to: "/#privacypolicy",
                                    onClick: function onClick() {
                                      return _this2.setFilter("privacypolicy");
                                    }
                                  },
                                  _localization2.default.privacy_policy_label
                                )
                              ),
                              _react2.default.createElement(
                                "li",
                                { className: this.isActive("rebrand") },
                                _react2.default.createElement(
                                  _reactRouterDom.Link,
                                  { to: "/rebrand" },
                                  _localization2.default.rebrand_label
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("about"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/#about",
                                id: "navAbout",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.about_us_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("openPositions"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              { to: "/openPositions" },
                              _localization2.default.open_positions_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("work"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/#workhere",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.work_culture_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("hiringProcess"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/hiringProcess",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.hiring_process_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("internWithUs"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              { to: "/internWithUs" },
                              _localization2.default.intern_with_us
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("team"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                id: "navTeam",
                                to: "/#team",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.team_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("social"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                id: "navSocial",
                                to: "/#social",
                                onClick: this.props.trackScrolling
                              },
                              _localization2.default.social_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("contact"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/#contact",
                                onClick: function onClick() {
                                  return _this2.setFilter("contact");
                                }
                              },
                              _localization2.default.contact_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              style: { backgroundColor: "b" },
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("privacypolicy"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              {
                                to: "/#privacypolicy",
                                onClick: function onClick() {
                                  return _this2.setFilter("privacypolicy");
                                }
                              },
                              _localization2.default.privacy_policy_label
                            )
                          ),
                          _react2.default.createElement(
                            "li",
                            {
                              style: { backgroundColor: "b" },
                              className: "hidden-lg hidden-md hidden-sm " + this.isActive("rebrand"),
                              "data-toggle": "collapse",
                              "data-target": "#navbar-collapse-2"
                            },
                            _react2.default.createElement(
                              _reactRouterDom.Link,
                              { to: "/rebrand" },
                              _localization2.default.rebrand_label
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Header;
}(_react2.default.Component);

exports.default = Header;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _header = __webpack_require__(49);

var _header2 = _interopRequireDefault(_header);

var _Footer = __webpack_require__(424);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RebrandPage = function (_React$Component) {
  _inherits(RebrandPage, _React$Component);

  function RebrandPage(props) {
    _classCallCheck(this, RebrandPage);

    return _possibleConstructorReturn(this, (RebrandPage.__proto__ || Object.getPrototypeOf(RebrandPage)).call(this, props));
  }

  _createClass(RebrandPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { height: '100vh' } },
        _react2.default.createElement(_header2.default, null),
        _react2.default.createElement(
          'div',
          {
            id: 'rebrand',
            className: 'section container-fluid rebrand-layout pageTitle'
          },
          _react2.default.createElement(
            'div',
            { className: 'rebrand-header' },
            _react2.default.createElement(
              'h1',
              { className: 'rebrand-header-mobile' },
              'We\'re now ',
              _react2.default.createElement(
                'span',
                null,
                'NicheSolv'
              )
            ),
            _react2.default.createElement('img', {
              src: '/images/rebranded-cover.png',
              alt: 'rebrandedImage',
              className: 'rebrand-image'
            }),
            _react2.default.createElement(
              'div',
              { className: 'rebrand-header-text' },
              _react2.default.createElement(
                'h1',
                null,
                'We\'re now ',
                _react2.default.createElement(
                  'span',
                  null,
                  'NicheSolv'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'rebrand-header-title' },
                'Yes, we are! We are now a Private Limited Company!'
              ),
              _react2.default.createElement(
                'p',
                { className: 'rebrand-header-title' },
                'However - due to name clashes - we\'ve chosen an alternate name- NicheSolv (\u0928\u093F\u0936 \u0938\u093E\u0932\u094D\u0935 or \u0CA8\u0CBF\u0CB6\u0CCD \u0CB8\u0CBE\u0CB2\u0CCD\u0CB5\u0CCD)'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'rebrand-content' },
            _react2.default.createElement(
              'div',
              { className: 'rebrand-meaning-container' },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Meaning'
                ),
                ' of NicheSolv ?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'rebrand-meaning-title' },
                'We love solving those hard-to-solve tech problems - so the new name better describes who we are!'
              ),
              _react2.default.createElement(
                'p',
                { className: 'rebrand-meaning-title' },
                'In Sanskrit - "\u0928\u093F\u0936\u093E\u0924\u093F" - means to "meditate deeply". So, you can say we meditate deeply (when needed only!) and solve your tech problems!'
              )
            ),
            _react2.default.createElement('img', {
              src: '/images/meaningOfNichesolv.jpg',
              alt: 'meaningOfNichesolv',
              className: 'meaning-of-nichesolv-image'
            }),
            _react2.default.createElement(
              'div',
              { className: 'rebrand-header-mobile' },
              _react2.default.createElement(
                'p',
                { className: 'rebrand-meaning-mobile' },
                'We love solving those hard-to-solve tech problems - so the new name better describes who we are!'
              ),
              _react2.default.createElement(
                'p',
                { className: 'rebrand-meaning-mobile' },
                'In Sanskrit - "\u0928\u093F\u0936\u093E\u0924\u093F" - means to "meditate deeply". So, you can say we meditate deeply (when needed only!) and solve your tech problems!'
              )
            )
          )
        ),
        _react2.default.createElement(_Footer2.default, null)
      );
    }
  }]);

  return RebrandPage;
}(_react2.default.Component);

exports.default = RebrandPage;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/rebrand.78260aed.js